import { Box, Button, Typography, useTheme } from "@mui/material";
import BigCarIcon from "../../../media/images/icons/bigCar";
import UserSquer from "../../../media/images/icons/userSquer";
import { useAppDispatch, useAppSelector } from "../../../hooks/useRedux";
import { handleUserLoginTabbar } from "../../../redux/features/settingSlice";
import { useEffect, useState } from "react";

interface Props {
  color: {
    main: string;
    light: string;
  };
  title: {
    title1: string;
    title2: string;
  };
}

export default function CustomTabbar({ color, title }: Props) {
  const appDispatch = useAppDispatch();
  const { userLoginTab } = useAppSelector((state) => state.setting);
  const theme = useTheme();
  const activeStyles = {
    flex: 1,
    paddingY: "10px",
    borderRadius: "20px",
    border: "1px solid",
    borderColor: `${color.main} !important`,
    backgroundColor: `${color.light} !important`,
    "& .MuiTouchRipple-root": {
      color: `${color.main} !important`,
      borderWidth: "0px !important",
    },
    "& .MuiButtonBase-root": {
      color: `${color.main} !important`,
      borderWidth: "0px !important",
    },
  };
  const inActiveStyles = {
    flex: 1,
    paddingY: "10px",
    borderRadius: "20px",
    "&.MuiTouchRipple-root": {
      color: `${color.main} !important`,
      borderWidth: "0px !important",
    },
    "&.MuiButtonBase-root": {
      color: `${color.main} !important`,
      borderWidth: "0px !important",
    },
    "&.MuiButton-root": {
      borderColor: `${color.main} !important`,
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        border: "1px solid #BDBDBD",
        borderWidth: "1px",
        borderRadius: "20px",
        boxSizing: "border-box",
      }}
    >
      <Button
        className="ahmad"
        onClick={() => appDispatch(handleUserLoginTabbar("burdenOwner"))}
        sx={userLoginTab === "burdenOwner" ? activeStyles : inActiveStyles}
      >
        <UserSquer
          color={
            userLoginTab === "burdenOwner"
              ? color.main
              : theme.palette.textColor.main
          }
        />
        <Typography
          sx={{
            color:
              userLoginTab === "burdenOwner"
                ? color.main
                : theme.palette.textColor.main,
            fontWeight: "600",
            marginRight: "5px",
          }}
        >
          {title.title1}
        </Typography>
      </Button>
      <Button
        className="ahmad"
        onClick={() => appDispatch(handleUserLoginTabbar("drivers"))}
        sx={userLoginTab === "drivers" ? activeStyles : inActiveStyles}
      >
        <BigCarIcon
          color={
            userLoginTab === "drivers"
              ? color.main
              : theme.palette.textColor.main
          }
        />
        <Typography
          sx={{
            color:
              userLoginTab === "drivers"
                ? color.main
                : theme.palette.textColor.main,
            marginRight: "5px",
            fontWeight: "600",
          }}
        >
          {title.title2}
        </Typography>
      </Button>
    </Box>
  );
}
